var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0715 62.8989C99.8504 34.364 66.6755 16.1876 56.6013 11.4236C46.5271 6.65954 39.0885 8.88652 28.848 21.6654C18.6076 34.4442 20.0477 56.5179 19.8988 65.8221C19.7499 75.1263 37.3478 98.5676 72.0715 62.8989Z",
    fill: "#94DEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 36.5186V59.064",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5098 36.5186V59.064",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.748 36.5186V59.064",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.748 36.5186V59.064",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24718 27.8599L31.3485 11.7034C31.6647 11.5216 32.0547 11.5264 32.3664 11.7158L58.9487 27.8723C59.8129 28.3975 59.4406 29.7269 58.4293 29.7269H3.74561C2.72155 29.7269 2.35939 28.3704 3.24718 27.8599Z",
    stroke: "#0056CD",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.58008,
    y: 64.7905,
    width: 54.5714,
    height: 5.45455,
    rx: 1.5,
    stroke: "#0056CD",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6368 21.7653C35.6368 23.6566 34.0099 25.3075 31.8545 25.3075C29.6991 25.3075 28.0723 23.6566 28.0723 21.7653C28.0723 19.874 29.6991 18.2231 31.8545 18.2231C34.0099 18.2231 35.6368 19.874 35.6368 21.7653Z",
    stroke: "#0056CD",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.d4cfc4fc.svg";
export { ForwardRef as ReactComponent };